import React from "react";

export default function Footer() {
  return (
    <footer className="bg-background text-primary py-6">
      <div className="mx-auto px-4 py-6 flex justify-center items-center">
        <div className="sm:text-sm xs:text-xs justify-center items-center text-center">
          <p>Designed by me using React, Typescript and Tailwind CSS.</p>
        </div>
      </div>
    </footer>
  );
}
